import { TZDateMini } from '@date-fns/tz'
import type { FmtDate, FmtDateTime, FmtTime } from '../types/functions'
import { getDtf } from './intl'

function castDate(
	date: Date | string,
	tz: string,
): InstanceType<typeof TZDateMini> {
	if (typeof date === 'string') return new TZDateMini(date, tz)
	else return new TZDateMini(date.toISOString(), tz)
}

export const fmtDate: FmtDate = (ctx, date, fmt) => {
	return getDtf(ctx.id, ctx.timezone, 'date', fmt).format(
		castDate(date, ctx.timezone),
	)
}

export const fmtTime: FmtTime = (ctx, date, fmt) => {
	return getDtf(ctx.id, ctx.timezone, 'time', fmt).format(
		castDate(date, ctx.timezone),
	)
}

export const fmtDateTime: FmtDateTime = (ctx, date, fmt) => {
	return getDtf(ctx.id, ctx.timezone, 'datetime', fmt).format(
		castDate(date, ctx.timezone),
	)
}
